import React from 'react';
import AutoCompleteFilter from 'components/list/Filters/types/AutoCompleteFilter';

const FunnelIdFilter = <AutoCompleteFilter
    label='filters.components.funnelId.label'
    options={ {
        fullWidth: true,
    } }
    searchParams={ {
        size: '12',
        sort_by: 'name',
        sort_direction: 'asc',
    } }
    reference='funnels'
    optionValue='id'
    searchBy='name'
    source='funnel_id'
/>;

export default FunnelIdFilter;



// WEBPACK FOOTER //
// ./src/components/form/filters/FunnelIdFilter.js